import React, { useEffect, useContext, useState } from 'react'
import { Link } from 'gatsby'

import { userContext } from 'global/context/sub-contexts/userContext'
import { themeContext } from 'global/context/sub-contexts/themeContext'

import DailySpin from './components/DailySpin'
import SignInUpNav from './components/SignInUpNav'
import ProfileDropdown from './components/ProfileDropdown'
import BrowserDetectorHelmet from './BrowserDetectorHelmet'
import LogoPNG from 'images/dblogo.png'
import logoSVG from 'images/logo.svg'
// import actionSearch from "images/icon-search.svg"
import actionSweepstakes from 'images/icon-card-giftcard.svg'
import { useSiteMetadata } from 'hooks/useSiteMetadata'
import './Header.scss'

//
// ######## Static content imported from plugins/gatsby-source-dailybreak-sample-breaks/sample-data/nav/header.json ########
//
const mainHeaderNavItems = [
  {
    name: 'Games',
    link: '/tag/games',
  },
  {
    name: 'Entertainment',
    link: '/tag/entertainment',
  },
  {
    name: 'Lifestyle',
    link: '/tag/lifestyle',
  },
  {
    name: 'Laugh',
    link: '/tag/laugh',
  },
  {
    name: 'Family',
    link: '/tag/family',
  },
]

const footerNavItems = [
  {
    name: 'How It Works',
    link: '/how-it-works',
    target: '_blank',
  },
  {
    name: 'Support',
    link: 'https://dailybreaksupport.groovehq.com/help',
    target: '_blank',
  },
  {
    name: 'Breaktime Media',
    link: 'https://www.breaktimemedia.com/',
    target: '_blank',
  },
  {
    name: 'Careers',
    link: 'https://www.breaktimemedia.com/careers',
    target: '_blank',
  },
]

//
// ######## End static data ########
//

const Header = () => {
  let colors = useContext(themeContext)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const user_context = useContext(userContext)
  const { isLoggedIn, userPoints, getProfile } = useContext(userContext)

  const [points, setPoints] = useState(0)

  const openMenuForMobile = () => {
    const element = document.getElementsByTagName('body')[0]
    element.classList.toggle('menu-open')
    setMobileMenuOpen(prev => !prev)
  }

  useEffect(() => {
    if (isLoggedIn()) {
      setPoints(user_context.points)
    } else {
      setPoints(0)
    }
  }, [user_context.points, isLoggedIn()])

  const metadata = useSiteMetadata()
  const { title } = metadata

  return (
    <>
      <header className={`header ${mobileMenuOpen ? 'sticky' : ''}`}>
        <div className="container">
          <div className="logo__container">
            <div className="logo__image">
              <Link to="/">
                <div className={`logo-variant-png`}>
                  <img src={LogoPNG} alt={title} className="logo" />
                </div>
                <div className={`logo-variant-svg`}>
                  <img src={logoSVG} alt={title} className="logo" />
                </div>
              </Link>
            </div>
          </div>
          <div className={`nav__container`}>
            <nav className="action-navigation">
              <ul className="action-nav">
                {/* <li>
                      <span>
                          <img
                              src={actionSearch}
                              alt="Search"
                              className="icn"
                          />{" "}
                      </span>
                  </li> */}
                <li className="hide-sm">
                  <DailySpin />
                </li>
                <li className="hide-sm">
                  <Link to="/rewards">
                    <span className="action__text">Sweepstakes</span>
                  </Link>
                </li>
                {isLoggedIn() && getProfile().guest === false ? (
                  <li className="user-nav">
                    <div className="user">
                      <span className="user__points">
                        <span>{points}</span> pts
                      </span>
                      <ProfileDropdown />
                    </div>
                  </li>
                ) : (
                  <li className="user-nav">
                    <SignInUpNav />
                  </li>
                )}
                <li className="hamburger" onClick={() => openMenuForMobile()}>
                  <div className="menu-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </li>
              </ul>
            </nav>

            <nav className="secondary-navigation">
              <ul className="menu">
                {mainHeaderNavItems.map((obj, index) => {
                  return (
                    <li key={index}>
                      {obj.link.startsWith('http') && (
                        <a href={obj.link} title={obj.name}>
                          {obj.name}
                        </a>
                      )}
                      {!obj.link.startsWith('http') && (
                        <Link to={obj.link} title={obj.name}>
                          {obj.name}
                        </Link>
                      )}
                    </li>
                  )
                })}
              </ul>
            </nav>
          </div>
        </div>
      </header>
      <div className="blank"></div>

      <nav className="mobile-nav">
        <ul className="mobile-nav__action">
          <li>
            <a href="#" title="Spin to wheel">
              <DailySpin />
            </a>
          </li>
          <li>
            <a href="/rewards" title="Sweepstakes">
              <img src={actionSweepstakes} alt="Sweepstakes" className="icn" />{' '}
              <span className="action__text">Sweepstakes</span>
            </a>
          </li>
        </ul>
        <ul className="mobile__menu">
          {footerNavItems.length &&
            footerNavItems.map((item, index) => {
              let target = item.target || '_self'
              let title = item.name || ''
              return (
                <li key={item.name} className="nav-item">
                  <a href={item.link} target={target} title={title}>
                    {item.name}
                  </a>
                </li>
              )
            })}
        </ul>
      </nav>
      <BrowserDetectorHelmet />
    </>
  )
}

export default Header
